import axios from "axios";
import { Howl } from "howler";


interface voiceOverType {
  curAudio: any;
  convertTextToAudio: Function;
  speak: Function;
  stop: Function;
  getUrl: Function;
}



export const voiceOver:voiceOverType = {

  curAudio:null,


  getUrl:()=>{
    let url = (document as any).querySelector('body').getAttribute('server');
    if (url === '{{$server_url}}') url = 'http://localhost:8200';
    url += '/voice/'
    return url
  },


  // Function to convert text to audio using ElevenLabs API
  convertTextToAudio: async (textToConvert:string,voice:string) => {
    const apiRequestOptions = {
      method: 'POST',
      url: voiceOver.getUrl(),
      data: {
        text: textToConvert,
        voice: voice,
      },
      withCredentials: false,
      responseType: 'arraybuffer', // To receive binary data in response
    };

    const apiResponse = await axios.request(apiRequestOptions as any);
    return apiResponse.data;
  },
 
// // Function to convert text to audio using ElevenLabs API
//  convertTextToAudio: async (textToConvert:string) => {
//   const apiRequestOptions = {
//     method: 'POST',
//     url: `https://api.elevenlabs.io/v1/text-to-speech/${voiceId}`,
//     headers: {
//       accept: 'audio/mpeg',
//       'content-type': 'application/json',
//       'xi-api-key': apiKey,
//     },
//     data: {
//       text: textToConvert,
//       model_id: "eleven_multilingual_v1",
//     },
//     responseType: 'arraybuffer', // To receive binary data in response
//   };

//   const apiResponse = await axios.request(apiRequestOptions as any);
//   return apiResponse.data;
// },
  // headers:
  // Content-Type: application/json
  // accept: audio/mpeg
  // xi-api-key: f56c5ccff622a9232be6be242a831235
  
  speak: async (text:string, voice:string, cb?:Function )=>{
    if (voiceOver.curAudio){
      (voiceOver.curAudio as any).unload();
    }

    console.log('CB',text)

    var audiodata = await voiceOver.convertTextToAudio(text,voice)
    var blob = new Blob([audiodata as any], { type: 'audio/mp3' });
    var url = window.URL.createObjectURL(blob);

    voiceOver.curAudio = new Howl({
      src:url,
      format: ['mp3'],
      html5: true,
      volume: 1      
    });

    voiceOver.curAudio.on('play',()=>{
      //console.log('Play');
    })
    voiceOver.curAudio.on('loaderror',(e:any)=>{
      console.log('ERROR LOADING',e);
    })
    voiceOver.curAudio.on('load',()=>{
      //console.log('Loaded');
    })
    voiceOver.curAudio.on('end',()=>{
      if (cb) cb()
      voiceOver.curAudio.unload()
    })

    voiceOver.curAudio.play();
  },


  stop:()=>{
    if (voiceOver.curAudio){
      (voiceOver.curAudio as any).unload();
    }
  }

}